import React, { useState, useEffect, useContext, useCallback, useRef, useMemo } from 'react';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import ThemeControls from "../Component/AllThemesControl";
import TableSortLabel from '@mui/material/TableSortLabel';
import TablePagination from '@mui/material/TablePagination';
import { FormContext } from '../Component/Forms/FormContext';
import Element from "./Element.js"
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import Dialog from '@mui/material/Dialog';
import FormHelperText from '@mui/material/FormHelperText';
import Button from '@mui/material/Button';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { MasterContext } from '../services/MasterContext';
import CloseIcon from '@mui/icons-material/Close';
import Controls from "./Control";
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import VendorCode from './Table.js'
import demo from './demo.json';
import elementValidation from '../Component/validation.js';
import { FormJSONCreateContext } from '../Component/FormJSONCreateContext.js';
//APISERVICES
import { APIGET, APIPATCH } from '../services/APIServices.js';
//import SuccessPage from '../SuccessPage';

//Navigation
import { useNavigate, Link } from 'react-router-dom';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: theme.palette.common.black,
        color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
    },
}));


function RenderRow({ index, row, columns, editJson, setFilteredData,setReplicate}) {
    const [arr, setArr] = useState(row);
    const handleChange = useCallback((id, event, value) => {
        setArr(prevArr => ({
            ...prevArr,
            [id]: value
        }));
        setFilteredData(prevArr => {
            const updatedArr = [...prevArr];
            updatedArr[index] = {
                ...updatedArr[index],
                [id]: value
            };
            return updatedArr; // Return the updated array
        });
        if(id){
            setReplicate(prevArr => {
                const updatedArr = [...prevArr];
                updatedArr[index] = {
                    ...updatedArr[index],
                    [id]: value
                };
                return updatedArr; // Return the updated array
            });
        }
    }, []);

    useEffect(()=>{
        setArr(row)
    },[row])

    return (
        <TableRow>
            {columns.map((column, i) => (
                <StyledTableCell key={column.field_id}>
                    {(column.field_type && column.field_type !== 'hidden') ?
                        <FormContext.Provider value={{ handleChange }}>
                            <Element 
                                key={i} 
                                field={{ 
                                    ...column, 
                                    field_label: "", 
                                    field_value: (column.field_id && arr.hasOwnProperty(column.field_id)) ? arr[column.field_id] : ((column.temp_id && arr.hasOwnProperty(column.temp_id)) ? arr[column.temp_id] : column.field_value)
                                }} 
                            />

                            {/* {editJson.fields && editJson.fields.map((field, i) => {
                                if (field.field_id === column.field_id) {
                                    field.field_label = '';
                                    field.field_value = arr[column.field_id];
                                    return (<Element key={i} field={field} />)
                                }
                            })
                            } */}
                        </FormContext.Provider> :
                        <div style={{ display: 'flex' }}>
                            <span></span>
                            <div>{(column.field_id && arr.hasOwnProperty(column.field_id)) ? arr[column.field_id] : ((column.temp_id && arr.hasOwnProperty(column.temp_id)) ? arr[column.temp_id] : '')}</div>
                        </div>
                    }
                </StyledTableCell>
            ))}
        </TableRow>
    );
}


export default function RoutingInfo(props) {
    const { useStyles, useStyle } = ThemeControls;
    const classes = useStyles();
    const classe = useStyle();
    const ref = useRef();
    // const { id, field_context, field_id, field_option_src } = props;
    const {id, field_type,field_apipath,field_context,field_history,fields, field_disabled_Edit,field_unique,field_id, field_label, field_placeholder,field_disabled, field_value,field_option_src, field_options,field_helperText,field_minlength,field_maxlength,field_maxvalue,field_value_type,field_minvalue,field_error_msg_required,field_error_msg_minlength,field_error_msg_maxlength,field_error_msg_minvalue,field_error_msg_maxvalue,field_error_msg_uq,onChange,field_mandatory } = props;
    const _columns = useMemo(() => {
        const columns = [];
        if (field_context) {
            Object.values(field_context).forEach((context) => {
                columns.push(...context.fields);
            });
        }
        return columns;
    }, [field_context]);

    const [dataSource, setDataSource] = useState([]);
    const [loading, setLoading] = useState(true);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [order, setOrder] = useState('asc');
    const [orderBy, setOrderBy] = useState('');
    const [open, setOpen] = React.useState(false);
    const [refresh, setRefresh] = useState(false);
    const [brValue, setBrValue] = useState('');
    const [field, setField] = useState({});
    const [errorMsg, setErrorMsg] = useState('');
    const [filteredData, setFilteredData] = useState([]);
    const [replicate, setReplicate] = useState([]);
    const [rlct, setRlct] = useState(false);
    const [editJson, setEditJson] = useState(field_context[Object.keys(field_context)[0]]);
    const { handleChange: handleChangeParent } = useContext(FormContext);
    const [btnLoading, setBtnLoading] = React.useState(false);
    const [selectedvendor, setSelectedvendor] = React.useState(0);
    const apiPath = `mm/marketmgt/gtsRoutingdetail/getRoutingDetailsByUserIdAndRoutingMasterId/${id}`;
    // let tempData=dataSource
    pdfMake.vfs = pdfFonts.pdfMake.vfs;
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
    const { contextJson } = React.useContext(FormJSONCreateContext);
    const navigate = useNavigate();
    const { Select, MultiSelectCheckBox } = Controls;
    const isAssigned = useRef(false);
    const field_validation = {
        field_id:field_id,
        field_unique:field_unique,
        field_apipath:field_apipath,
        field_type:field_type,
        field_disabled:field_disabled,
        field_value:field_value,
        field_helperText:field_helperText,
        field_minlength:field_minlength,
        field_maxlength:field_maxlength,
        field_minvalue:field_minvalue,
        field_maxvalue:field_maxvalue,
        field_value_type:field_value_type,
        field_mandatory:field_mandatory,
        field_options: field_options ,
        field_label:field_label
      }

    useEffect(() => {
        const handleClickOutside = (event) => {
          if (ref.current && !ref.current.contains(event.target)) {
            elementValidation(field_validation)
            // //console.log('hello')
          }
        };
        document.addEventListener('mousedown', handleClickOutside);
    
        return () => {
          document.removeEventListener('mousedown', handleClickOutside);
        };
      }, []);

    useEffect(() => {
        async function fetchData() {
            try {
                const response = await APIGET(apiPath);
                if (response.data) {
                    setDataSource(Array.isArray(response.data) ? response.data : [response.data]);
                    setFilteredData(response.data);
                }
            } catch (error) {
                console.error('Error fetching data:', error);
            } finally {
                setLoading(false);
            }
        }

        if (apiPath&&id) {
            fetchData();
        }
    }, [apiPath, refresh]);

    useEffect(() => {
       if(filteredData&&filteredData.length>0){
        const data = {};
        let sum = 0;
        let ACPM = 0;
        let mmtype = '';
        let AllocValue = []
        filteredData.forEach(item => {
            //console.log(item)
            const allocation = parseInt(item?.allocation || 0);
            const rate = parseFloat(item?.rate || 0);

            sum += allocation;
            ACPM += (rate * allocation) / 100;
        });

          Object.keys(contextJson).forEach((key, _i) => {
            if (key !== "xioFEConfig") {
                let _object = contextJson[key];
                _object.fields.forEach(field => {
                    // if(field.field_id==="acpm"){
                    //     field.field_value=ACPM;
                    // }   
                    if(field.field_id==="selectedvendor"){
                        field.field_value=selectedvendor;
                    }   
                    if(field.field_id==="breakout"&&id){
                        if(!isAssigned.current){                    
                            setBrValue(field.field_value)
                            isAssigned.current = true;
                        }
                        setField(field)
                    }   
            if(field.field_id==="mmtype" && field.field_value == "1"){
                mmtype = field.field_value;
                AllocValue = filteredData.map(item => ({
                    allocation: item?.allocation || 0,
                    overflow: item?.overflow || 0,
                    breakout: item.breakout,
                    quality: item.quality,
                  }));
             } else if(field.field_id==="mmtype" && field.field_value == "2"){
                AllocValue = []
                mmtype = field.field_value;
             }
        }); 
            }})

        const BreakoutMain = {
            "ID": filteredData.map(item => item.breakout)[0],
            "Source": "AudienceBuilder"
        };
        const updatedData = filteredData.map((item, index) => ({
            "Condition": {
                "BreakoutCond": item.breakout,
                "techprefix": item.techPrefix,
                "quality": item.quality,
                "rate": item.rate,
                "allocation": item.allocation?item.allocation:'0',
                "overflow": item.overflow?item.overflow:'0',
                "inService": item.inService?item.inService:'',
                "remark": item.remark?item.remark:'',
            },
            "ID": item.vendorId
        }));
         BreakoutMain["Vendor"] = updatedData
        data["BreakoutMain"] = BreakoutMain;
        handleChangeParent(field_id, ACPM, data,AllocValue);
       }
    }, [filteredData]);

    const handlePageChange = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - dataSource.length) : 0;

    const visibleRows = React.useMemo(
        () =>
           dataSource.slice(
                page * rowsPerPage,
                page * rowsPerPage + rowsPerPage,
            ),
        [order, orderBy, page, rowsPerPage, dataSource],
    );
    // //console.log(dataSource)
    // //console.log(visibleRows)
    // useEffect(() => {
    //     const startIndex = page * rowsPerPage;
    //     const endIndex = startIndex + rowsPerPage;
    //     setDataSource(filteredData.slice(startIndex, endIndex));
    // }, [filteredData, page, rowsPerPage]);

    function validateThisForm(jsonContext) {
        let return_error = true;
        jsonContext.fields.forEach(field => {
            if(field.field_type!=="routingInfo"){
                if (!elementValidation(field)) {
                    return_error = false;
                     
                    return false;
                }
            }
        });
        return return_error;
      }

      async function fetchData(path) {
        try {
            const response = await APIGET(path);
            if (response.data && response.data.length > 0 && !id) {
                //console.log(response.data)
                setErrorMsg('Routing Already exist for selected breakout')
                setBtnLoading(false)
                return false;
            } else {
                setErrorMsg('')
                setBtnLoading(false)
                return true;
            }
        } catch (error) {
            console.error('Error fetching data:', error);
            return true;
        }
    }
    
    const handleOpenMenu = async () => {
        let isFormValid = true; 
        let isDataFound = true; 
        Object.keys(contextJson).forEach((key, _i) => {
            if (key !== "xioFEConfig") {
                let _object = contextJson[key];
                isFormValid = (validateThisForm(_object));
                //console.log(_object.fields)
                let product = _object.fields.find(item => item.field_id === 'product').field_value;
                let country = _object.fields.find(item => item.field_id === 'country').field_value;
                let breakout = _object.fields.find(item => item.field_id === 'breakout').field_value;
                let mmtype = _object.fields.find(item => item.field_id === 'mmtype').field_value;
                
                // Encoding the values for URL
                country = encodeURIComponent(country);
                // breakout = encodeURIComponent(breakout);
                let multipleBreakOut = breakout.split(', ')
                 let brString = encodeURIComponent(multipleBreakOut.join(','))
                 //console.log(brString)
                mmtype = encodeURIComponent(mmtype);
                
                // Creating the dynamic URL
                let path = `mm/marketmgt/gtsRoutingmaster/searchMmRequest?product=${product}&country=${country}&breakout=${brString}&mmtype=${mmtype}/all`;
                
                // Await the result of fetchData
                if(isFormValid ){
                    setBtnLoading(true)
                    fetchData(path).then(result => {
                        isDataFound = result;
                        if (isDataFound) {
                            setOpen(true);
                        }else{
                            let _te = document.getElementById(field_id);
                            _te.parentNode.nextSibling.textContent = 'Routing Already exist for selected breakout'
                            setErrorMsg('Routing Already exist for selected breakout')
                        }
                    });
                }
            }
        });
    };
    
    // useEffect(()=>{
    //     let totalSum = 0;
    // Object.keys(contextJson).forEach((key, _i) => {
    //     if (key !== "xioFEConfig") {
    //     contextJson[key].fields.forEach((item)=>{
    //         if(item.field_id==='vendorDetailXMl' && item.field_value){
    //             item.field_value.BreakoutMain.Vendor.forEach((subItem)=>{
    //                 if (subItem.Condition.allocation) {
    //                     const result = (subItem.Condition.allocation / 100) * subItem.Condition.rate;
    //                     totalSum += result;
    //                 }
    //             })
    //         }
    //         if(item.field_id==='acpm'){
    //             item.field_value= totalSum;
    //         }
    //     })
           
    //     }})
    // })
    function relicateCancle(){
        setRlct(false)
        handleChange(id,{},brValue)
    }

    function handleChange(id,event,value){
        const Mbreakout = value.split(', ');
        const vendordetailArr = [];
        if(Mbreakout.length>0){
            replicate.forEach(vendor => {
                Mbreakout.forEach(brkout => {
                    let newVendor = { ...vendor, breakout: brkout };
                    vendordetailArr.push(newVendor);
                    //console.log(newVendor);
                });
            });
        }

        Object.keys(contextJson).forEach((key, _i) => {
            if (key !== "xioFEConfig") {
                let _object = contextJson[key];
                _object.fields.forEach(field => {

                    if (field.field_id === "breakout" && id) {
                        field.field_value=value
                    }
                });
            }
        })

    setDataSource(vendordetailArr);
    setFilteredData(vendordetailArr);
    }
    //console.log(brValue)
    return (
        <>
            <Dialog className={classes.popupEdit}
                maxWidth={fullScreen}
                open={open}
                // onClose={() => setOpen(false)}
            >
                <VendorCode field_id={field_id} setSelectedvendor={setSelectedvendor} field_option_src={field_option_src} close={() => setOpen(false)} setDataSource={setDataSource} setFilteredData={setFilteredData} setReplicate={setReplicate}/>
            </Dialog>
            <div className={classe.breakForm}>
            <div className={classe.btnMenu}>
                {!rlct&&<button id={field_id} disabled={btnLoading} onClick={handleOpenMenu}>
            {btnLoading?
                  <div class={classes.loading08}>
                    <span data-text="L">L</span>
                    <span data-text="O">O</span>
                    <span data-text="A">A</span>
                    <span data-text="D">D</span>
                    <span data-text="I">I</span>
                    <span data-text="N">N</span>
                    <span data-text="G">G</span>
                  </div>: "Select Vendors"
                  }
                </button>}
                {id&&replicate.length>0&&(rlct?<button onClick={relicateCancle}>Cancel</button>:<button onClick={()=>setRlct(true)}>Replicate</button>)}
                    {rlct&&<FormContext.Provider value={{ handleChange }}>
                            <MultiSelectCheckBox
                                field_id={field.field_id}
                                field_label={field.field_label}
                                field_value={field.field_value}
                                field_default_value={field.field_default_value}
                                field_placeholder={field.field_placeholder}
                                field_mandatory={field.field_mandatory}
                                field_option_src={field.field_option_src}
                                field_options={field.field_options}
                                field_type={field.field_type}
                                field_helperText={field.field_helperText}
                                field_minlength={field.field_minlength}
                                field_maxlength={field.field_maxlength}
                                field_minvalue={field.field_minvalue}
                                field_maxvalue={field.field_maxvalue}
                                field_value_type={field.field_value_type}
                                field_on_blur={field.field_on_blur}
                                field_error_msg_required={field.field_error_msg_required}
                                field_error_msg_minlength={field.field_error_msg_minlength}
                                field_error_msg_maxlength={field.field_error_msg_maxlength}
                                field_error_msg_minvalue={field.field_error_msg_minvalue}
                                field_error_msg_maxvalue={field.field_error_msg_maxvalue}
                                field_runtime_ops={field.field_runtime_ops}
                            />
                    </FormContext.Provider>}
                </div>
                
            <FormHelperText>{errorMsg?errorMsg:""}</FormHelperText>
            </div>
            {dataSource.length>0&&<div className={classe.breakForm}>
                <TableContainer className={classes.table}>
                    <Table aria-label="customized table">
                        <TableHead>
                            <TableRow>
                                {_columns.map((column) => (
                                    <StyledTableCell key={column.field_id}>
                                        <TableSortLabel>
                                            {column.field_label}
                                        </TableSortLabel>
                                    </StyledTableCell>
                                ))}
                            </TableRow>
                        </TableHead>
                        <TableBody ref={ref}>
                            {visibleRows.map((row, index) => (
                            // {dataSource.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, index) => (
                                <RenderRow key={index} index={index} row={row} columns={_columns} editJson={editJson} setEditJson={setEditJson} tempData={filteredData} setFilteredData={setFilteredData} setReplicate={setReplicate}/>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
                <div className={classes.pagination}>
                    <TablePagination
                        component="div"
                        labelRowsPerPage='Show row per page'
                        count={dataSource.length}
                        page={page}
                        onPageChange={handlePageChange}
                        rowsPerPage={rowsPerPage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                        rowsPerPageOptions={[10, 50, 100, 500]}
                    />
                </div>
            </div>}
        </>
    );
}
